import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Header, Footer } from '../components';
import { steamLoginUrl } from '../lib/api/scanApi';
import { getStoredSteamId, getBillingStatus, startCheckout, openPortal } from '../lib/api/billingApi';

// Comparatif : clé i18n + dispo Free / Pro.
const FEATURES = [
  { key: 'f_scan', free: true, pro: true },
  { key: 'f_verdict', free: true, pro: true },
  { key: 'f_gog', free: true, pro: true },
  { key: 'f_lists', free: true, pro: true },
  { key: 'f_pscore', free: true, pro: true },
  { key: 'f_alerts', free: false, pro: true },
  { key: 'f_price_alerts', free: false, pro: true },
  { key: 'f_savable', free: false, pro: true },
  { key: 'f_savelist', free: false, pro: true },
  { key: 'f_watch', free: false, pro: true },
];

function Check({ on }) {
  return <span className={`price-feat__mark ${on ? 'is-on' : 'is-off'}`}>{on ? '✓' : '—'}</span>;
}

function PricingPage() {
  const { t } = useTranslation();
  const [plan, setPlan] = useState('monthly');
  const [steamId] = useState(getStoredSteamId);
  const [isPro, setIsPro] = useState(false);
  const [busy, setBusy] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const success = params.get('success') === '1';
  const canceled = params.get('canceled') === '1';

  useEffect(() => {
    if (!steamId) return;
    getBillingStatus(steamId)
      .then(({ data }) => setIsPro(!!data.isPro))
      .catch(() => {});
  }, [steamId]);

  const goPro = () => {
    if (!steamId) {
      window.location.href = steamLoginUrl();
      return;
    }
    setBusy(true);
    startCheckout({ steamId, plan })
      .then(({ data }) => {
        if (data.url) window.location.href = data.url;
        else setBusy(false);
      })
      .catch(() => setBusy(false));
  };

  const manage = () => {
    if (!steamId) return;
    setBusy(true);
    openPortal(steamId)
      .then(({ data }) => {
        if (data.url) window.location.href = data.url;
        else setBusy(false);
      })
      .catch(() => setBusy(false));
  };

  const proPrice = plan === 'annual' ? '49€' : '4,99€';
  const proSuffix = plan === 'annual' ? t('pricing.per_year') : t('pricing.per_month');

  return (
    <div className="app-shell">
      <Header />
      <main className="app-main">
        <section className="pricing">
          <a className="pricing__back" href="/">{t('pricing.back')}</a>
          <h1 className="pricing__title">{t('pricing.title')}</h1>
          <p className="pricing__subtitle">{t('pricing.subtitle')}</p>

          {success && <div className="pricing__flash pricing__flash--ok">{t('pricing.success')}</div>}
          {canceled && <div className="pricing__flash">{t('pricing.canceled')}</div>}

          <div className="pricing__toggle">
            <button
              type="button"
              className={`pricing__toggle-btn ${plan === 'monthly' ? 'is-active' : ''}`}
              onClick={() => setPlan('monthly')}
            >
              {t('pricing.monthly')}
            </button>
            <button
              type="button"
              className={`pricing__toggle-btn ${plan === 'annual' ? 'is-active' : ''}`}
              onClick={() => setPlan('annual')}
            >
              {t('pricing.annual')} <span className="pricing__save">{t('pricing.annual_hint')}</span>
            </button>
          </div>

          <div className="pricing__cards">
            {/* FREE */}
            <div className="price-card">
              <div className="price-card__name">{t('pricing.free_name')}</div>
              <div className="price-card__price">{t('pricing.free_price')}</div>
              <ul className="price-feats">
                {FEATURES.map((f) => (
                  <li key={f.key} className="price-feat">
                    <Check on={f.free} />
                    {t(`pricing.${f.key}`)}
                  </li>
                ))}
              </ul>
              <div className="price-card__cta price-card__cta--current">{t('pricing.cta_free')}</div>
            </div>

            {/* PRO */}
            <div className="price-card price-card--pro">
              <div className="price-card__badge">PRO</div>
              <div className="price-card__name">{t('pricing.pro_name')}</div>
              <div className="price-card__price">
                {proPrice}
                <span className="price-card__suffix">{proSuffix}</span>
              </div>
              <ul className="price-feats">
                {FEATURES.map((f) => (
                  <li key={f.key} className={`price-feat ${!f.free && f.pro ? 'is-highlight' : ''}`}>
                    <Check on={f.pro} />
                    {t(`pricing.${f.key}`)}
                  </li>
                ))}
              </ul>
              {isPro ? (
                <>
                  <div className="price-card__cta price-card__cta--pro-active">{t('pricing.already_pro')}</div>
                  <button
                    type="button"
                    className="btn btn--ghost price-card__btn price-card__manage"
                    onClick={manage}
                    disabled={busy}
                  >
                    {busy ? '…' : t('pricing.manage')}
                  </button>
                </>
              ) : (
                <button type="button" className="btn btn--amber price-card__btn" onClick={goPro} disabled={busy}>
                  {busy ? '…' : steamId ? t('pricing.cta_pro') : t('pricing.need_scan')}
                </button>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default PricingPage;
